import React, { FC } from "react";
import { RecommendationTranslationInsuranceDto } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";

import { StyledCard } from "./Subsidy.styled";

import {
  Button,
  Grid,
  Typography,
  Card,
  CardContent,
  Divider,
} from "@components/base";

interface Component {
  subsidy: RecommendationTranslationInsuranceDto;
}

const Component: FC<Component> = ({ subsidy }) => {
  const { t } = useTranslation();
  const { title, text, link, link_name } = subsidy;

  return (
    <Card>
      <CardContent>
        <Typography variant="h6">{t(title)}</Typography>
        <StyledCard>
          <Grid container spacing={3} alignItems="center">
            <Grid size={{ xs: 12, md: 2 }} textAlign="center">
              <img src="/static/cards/subsidy-green.svg" width={120} />
            </Grid>
            <Grid size={{ xs: 12, md: 10 }}>
              <Grid container spacing={{ xs: 2, md: 3 }} direction="column">
                <Grid size={12}>
                  <Typography variant="h5" fontWeight={700}>
                    {t(text)}
                  </Typography>
                </Grid>
                <Grid size={12}>
                  <Grid container spacing={{ xs: 2, md: 3 }}>
                    <Grid size={{ xs: 12, md: "auto" }}>
                      <Typography variant="body2" color="textSecondary">
                        {t("subsidy.amount")}
                      </Typography>
                      <Typography fontWeight={700}>
                        {t("subsidy.amountValue")}
                      </Typography>
                    </Grid>
                    <Grid display={{ xs: "none", md: "flex" }}>
                      <Divider orientation="vertical" />
                    </Grid>
                    <Grid size={{ xs: 12, md: "auto" }}>
                      <Typography variant="body2" color="textSecondary">
                        {t("subsidy.status")}
                      </Typography>
                      <Typography fontWeight={700}>
                        {t("subsidy.statusValue")}
                      </Typography>
                    </Grid>
                    <Grid display={{ xs: "none", md: "flex" }}>
                      <Divider orientation="vertical" />
                    </Grid>
                    <Grid size={{ xs: 12, md: "auto" }}>
                      <Typography variant="body2" color="textSecondary">
                        {t("subsidy.condition")}
                      </Typography>
                      <Typography fontWeight={700}>
                        {t("subsidy.conditionValue")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid size={12}>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="flex-end"
                    spacing={{ xs: 2, md: 3 }}
                  >
                    <Grid size={{ xs: 12, md: "auto" }}>
                      <Typography
                        variant="caption"
                        maxWidth={326}
                        color="textSecondary"
                        fontStyle="italic"
                        display="inline-block"
                        textAlign="end"
                      >
                        {t("subsidy.caption")}
                      </Typography>
                    </Grid>
                    {link && (
                      <Grid size={{ xs: 12, md: "auto" }}>
                        <Button variant="outlined" fullWidth href={link}>
                          {link_name}
                        </Button>
                      </Grid>
                    )}
                    <Grid size={{ xs: 12, md: "auto" }}>
                      <Button fullWidth>{t("subsidy.interested")}</Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </StyledCard>
      </CardContent>
    </Card>
  );
};

export default Component;
